/* eslint-disable react/forbid-prop-types */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { Message } from 'primereact/message';

function AprroveModal({ visible, onClose, onSubmit, isSubmitting }) {
  const { t } = useTranslation();

  return (
    <Dialog
      header={<p className="text-blue-500">{t('projectAdjustment.approveModal.title')}</p>}
      visible={visible}
      position="center"
      style={{ width: '600px' }}
      onHide={onClose}
      draggable={false}
    >
      <Message
        severity="info"
        text={t('projectAdjustment.approveModal.description')}
        className="mb-4"
      />
      <div className="flex justify-content-end gap-2">
        <Button
          type="button"
          label={t('employee.cancel')}
          className="w-7rem"
          severity="danger"
          onClick={onClose}
          autoFocus
        />
        <Button
          label={t('employee.ok')}
          className="w-7rem"
          severity="info"
          type="submit"
          onClick={onSubmit}
          disabled={isSubmitting}
        />
      </div>
    </Dialog>
  );
}

AprroveModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

AprroveModal.defaultProps = {
  visible: false,
  onClose: () => {},
  onSubmit: () => {},
  isSubmitting: false,
};

export default React.memo(AprroveModal);
